// Small badges used to mark sections as Live vs Mock — Phase 2C.
import { Database, FlaskConical, Info } from "lucide-react";

export const LiveBadge = ({ live }) =>
  live ? (
    <span
      data-testid="badge-live"
      className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-emerald-700 ring-1 ring-inset ring-emerald-600/20"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" />
      Live
    </span>
  ) : (
    <span
      data-testid="badge-mock"
      title="Visual mock — replaced with live data in a later phase."
      className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-amber-800 ring-1 ring-inset ring-amber-600/30"
    >
      <FlaskConical className="h-3 w-3" />
      Mock — Phase 2D+
    </span>
  );

export const SourceTag = ({ live }) =>
  live ? (
    <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-emerald-700">
      <Database className="h-3 w-3" /> Live data
    </span>
  ) : (
    <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-amber-700">
      <FlaskConical className="h-3 w-3" /> Mock data
    </span>
  );

/**
 * Standardised "Not available yet" panel used in live mode wherever a surface
 * has no real ShelfLife data behind it. Renders an explicit explanation
 * instead of mock numbers. No fabricated figures appear inside.
 */
export const UnavailablePanel = ({ title, reason, testId }) => (
  <div
    data-testid={testId || "unavailable-panel"}
    className="rounded-xl border border-slate-200 bg-white p-6"
  >
    <div className="flex items-start gap-3">
      <span className="flex h-8 w-8 items-center justify-center rounded-md bg-slate-100 text-slate-500 shrink-0">
        <Info className="h-4 w-4" />
      </span>
      <div className="min-w-0">
        <h3 className="text-sm font-semibold text-slate-900">
          {title || "Not available yet"}
        </h3>
        <p className="mt-1 text-sm text-slate-600 leading-relaxed">
          {reason ||
            "ShelfLife does not currently expose this data through the read-only platform API. No mock data is shown."}
        </p>
      </div>
    </div>
  </div>
);
